import { isPisysSite } from "./Controllers";

export function setDocTitle(text = "") {
  if (isPisysSite()) {
    document.title = `${text}`;
  } else {
    document.title = `${text} | Vetropack`;
  }
}
